import {Spin} from "antd";
import {LoadingOutlined} from "@ant-design/icons";
import {useEffect, useState} from "react";

export const Loading = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(true);
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  if (!show) {
    return;
  }

  return <Spin fullscreen indicator={<LoadingOutlined spin style={{fontSize: 72}} />} size="large" tip="Loading..." />;
};
